import { fetchInvoicePdf } from "@/lib/api/invoice";
import { saveAndShareFile } from "@/lib/capacitor";
import { useState } from "react";
import { toast } from "sonner";

interface DownloadInvoiceButtonProps {
  id: string;
}

export default function DownloadInvoiceButton({
  id,
}: DownloadInvoiceButtonProps) {
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    setDownloading(true);
    try {
      const result = await fetchInvoicePdf(id);
      if (!result) {
        toast.error("Unable to download invoice");
        return;
      }

      await saveAndShareFile({
        filename: result.filename,
        data: result.data,
        mimeType: "application/pdf",
      });
    } catch {
      toast.error("Unable to download invoice");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <button
      onClick={handleDownload}
      disabled={downloading}
      className="rounded bg-black px-4 py-2 text-sm font-medium text-white disabled:opacity-60"
    >
      {downloading ? "Downloading..." : "Download PDF"}
    </button>
  );
}
